import { defineComponent, h } from 'vue'
import { mapState, mapActions } from 'vuex'

// 3rd parties
import ga from '@/3rd-parties/ga.ts'

// constants
import { APPLICATION_PAGES } from '@/constants'

export default (component: any) => defineComponent({
  computed: {
    ...mapState({
      selectedStatus: (state: any) => state.selections.selectedStatus,
      questions: (state: any) => state.questions,
    }),
  },
  methods: {
    ...mapActions(['setSelectedStatusAction']),
  },
  render() {
    return h(component, {
      ...this.$attrs,
      selectedStatus: this.selectedStatus,
      questions: this.questions,
      handleActiveStatusChange: (status: string) => {
        ga.trackEvent(APPLICATION_PAGES.QA, 'Status > Change > Submit', status)
        this.setSelectedStatusAction(status)
      },
    })
  },
})
